type PromptPayload =
  | string
  | { title?: string; description: string; placeholder?: string };

const handlePrompt: (payload: PromptPayload) => Promise<string> = (payload) =>
  new Promise((resolve, reject) => {
    dispatchEvent(
      new CustomEvent('showPrompt', {
        detail: payload,
      }),
    );
    const successCallback = (e) => {
      const value = e.detail;

      if (value) {
        resolve(value);
      } else {
        reject();
      }
      removeEventListener('submitPrompt', successCallback);
    };
    const rejectCallback = () => {
      reject();
      removeEventListener('rejectPrompt', rejectCallback);
    };
    addEventListener('submitPrompt', successCallback);
    addEventListener('rejectPrompt', rejectCallback);
  });

export const _prompt = async (
  payload: PromptPayload,
  onSuccess?: (value: string) => void,
  onReject?: (value: null) => void,
) => {
  try {
    const value = await handlePrompt(payload);

    onSuccess && onSuccess(value);
    return value;
  } catch (e) {
    onReject && onReject(null);
    return null;
  }
};
